module.exports = __webpack_public_path__ + "img/601.081dd3a6.jpg";